// Pricing Page
import React from 'react';
import '../../App.css';
import styles from '../Services.module.css';
import Footer from '../Footer';

export default function Services() {
  return (
    <>
      <div className={styles['services-pricing']}>
        <div className={styles['pricing-cards']}>
          {/* Premium Option */}
          <div className={styles['pricing-card']}>
            <h2>Premium</h2>
            <p className={styles.price}>
              £5 <span className={styles['billing-cycle']}>/month</span>
            </p>
            <ul className={styles['pricing-features']}>
              <li>Premium AI Token Limit</li>
              <li>First access to additional features</li>
              <li>Beta access to new features (Optional) </li>
            </ul>
            <button className={styles['btn-buy']}>Subscribe Now</button>
          </div>

          {/* Corporate Option */}
          <div className={styles['pricing-card']}>
            <h2>Standard</h2>
            <p className={styles.price}>
              £0.99 <span className={styles['billing-cycle']}>/month</span>
            </p>
            <ul className={styles['pricing-features']}>
              <li>Standard AI Token Limit</li>
              <li>No access to additional features</li>
              <li>No beta access to additional features </li>
            </ul>
            <button className={styles['btn-buy']}>Subscribe Now</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
